import {css} from 'aphrodite';
import classNames from 'classnames';
import React, {useRef} from 'react';
import _ from 'underscore';

import {sharedStyles} from 'processes/settings/fields/ProcessTaskSchemaFieldConstants';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';

interface CanSetAssigneeOnTaskCreationFieldProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled: boolean;
  hideWithMessage?: string | null;
}

export default function CanSetAssigneeOnTaskCreationField(
  props: CanSetAssigneeOnTaskCreationFieldProps
): JSX.Element {
  const wrapperIdRef = useRef(_.uniqueId('catSetAssigneeOnTaskCreationWrapper'));
  const checkboxIdRef = useRef(_.uniqueId('catSetAssigneeOnTaskCreationCheckbox'));

  return (
    <InputWrapper
      id={wrapperIdRef.current}
      label="Assignee"
      labelStyle={FieldLabel.STYLES.LABEL}
      dataTestAttrs={{component: 'CanSetAssigneeOnTaskCreationField', element: 'root'}}
    >
      {props.hideWithMessage ? (
        <span className={css(sharedStyles.messageText)}>{props.hideWithMessage}</span>
      ) : (
        <div className={classNames(css(sharedStyles.checkboxWrapper), 'editableField')}>
          <CheckboxInput
            id={checkboxIdRef.current}
            className={css(sharedStyles.checkboxField)}
            label="Can set assignee on task creation"
            checked={props.value}
            disabled={props.disabled}
            onChange={(e) => {
              props.onChange(e.target.checked);
            }}
          />
        </div>
      )}
    </InputWrapper>
  );
}
